module.exports = "/fonts/vendor/@fontsource/roboto/files/roboto-greek-ext-700-normal.woff2?bd9854c751441ccc1a704e09f638e4d3";